import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export const fields = () => {
  const hasAccess = store.getters['identity/hasAccess']
  const hasTrackerAccess = hasAccess(['driver_app_tracker:read'])
  const SUPPORTED = 'Supported'

  const commonFields = [
    {
      key: 'licensePlate',
      label: 'global.object.licensePlate',
      isSortable: true,
      isRedirectable: true,
      isLocked: true,
      ...(hasTrackerAccess && { rowspan: 2 }),
    },
    {
      key: 'vehicle2Vgroup',
      label: 'global.object.fleetGroup',
      isSortable: true,
      ...(hasTrackerAccess && { rowspan: 2 }),
      formatter: (val) => {
        if (!val || !Array.isArray(val) || val.length === 0) return '-'
        return val
          .map((item) => item.vgroup?.name)
          .filter(Boolean)
          .join(', ')
      },
    },
    {
      key: 'vehicleType.type',
      label: 'global.field.vehicleType',
      isSortable: true,
      ...(hasTrackerAccess && { rowspan: 2 }),
    },
    {
      key: 'driver1.fullname',
      label: 'global.object.driver',
      isSortable: true,
      formatter: (val) => val ?? '-',
      ...(hasTrackerAccess && { rowspan: 2 }),
    },
    {
      key: 'hullNo',
      label: 'global.object.hullNo',
      isSortable: true,
      formatter: (val) => val ?? '-',
      ...(hasTrackerAccess && { rowspan: 2 }),
    },
    {
      key: 'odometer',
      label: 'master.list.fleet.odometer',
      isSortable: true,
      formatter: (val) => (val ? `${Helper.methods.thousandFormat(val)} Km` : '-'),
      ...(hasTrackerAccess && { rowspan: 2 }),
    },
    {
      key: 'identificationSupport.face',
      label: 'rfidAndFacerecognition.fieldsHeader.faceRecognition',
      isShow: hasAccess(['d10a-default-rfid&fr:read']),
      formatter: (val) => {
        if (val === SUPPORTED) {
          return {
            text: 'rfidAndFacerecognition.cameraSupported',
            icon: 'icon-fill_checkmark-circle text-success',
          }
        } else {
          return {
            text: 'rfidAndFacerecognition.notSupported',
            icon: 'icon-fill_close-circle text-secondary',
          }
        }
      },
      ...(hasTrackerAccess && { rowspan: 2 }),
    },
    {
      key: 'identificationSupport.rfid',
      label: 'rfidAndFacerecognition.fieldsHeader.rfId',
      isShow: hasAccess(['d10a-default-rfid&fr:read']),
      formatter: (val) => ({
        text:
          val === SUPPORTED
            ? 'rfidAndFacerecognition.supported'
            : 'rfidAndFacerecognition.notSupported',
        icon:
          val === SUPPORTED
            ? 'icon-fill_checkmark-circle text-success'
            : 'icon-fill_close-circle text-secondary',
      }),
      ...(hasTrackerAccess && { rowspan: 2 }),
    },
    {
      key: 'status',
      label: 'master.list.fleet.status',
      isSortable: true,
      ...(hasTrackerAccess && { rowspan: 2 }),
      formatter: (val) => {
        if (val == 'I') {
          return { text: 'global.active', class: 'mc-status mc-status--green' }
        } else if (val == 'R') {
          return { text: 'global.repair', class: 'mc-status mc-status--blue' }
        } else {
          return { text: 'global.archive', class: 'mc-status mc-status--red' }
        }
      },
    },
  ]

  const [licensePlate, vehicle2Vgroup, vehicleType, ...restFields] = commonFields

  if (hasTrackerAccess) {
    return [
      licensePlate,
      vehicle2Vgroup,
      vehicleType,
      {
        key: 'vehicleType.category',
        label: 'global.field.vehicleCategory',
        isSortable: true,
        rowspan: 2,
        isShow: hasAccess(['driver-compatibility:update']),
      },
      {
        key: 'tracker',
        label: 'master.pelacak',
        rowspan: 1,
        colspan: 2,
        isHeader: true,
        fields: [
          {
            key: 'imei',
            label: 'master.list.fleet.trackerId',
            isSortable: true,
            formatter: (val) => val ?? '-',
            shown: true,
            isLocked: true,
          },
          {
            key: 'driver1.email',
            label: 'master.list.fleet.email',
            isSortable: true,
            formatter: (val) => val ?? '-',
            shown: true,
            isLocked: true,
          },
        ],
      },
      ...restFields,
    ]
  }

  return [
    licensePlate,
    vehicle2Vgroup,
    vehicleType,
    {
      key: 'imei',
      label: 'master.list.tracker.imei',
      isSortable: true,
      formatter: (val) => val ?? '-',
      shown: true,
    },
    ...restFields,
  ]
}
